import React from "react";

export const FormIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28px"
        height="28px"
        viewBox="0 0 32 32"
        version="1.1"
      >
        <g
          stroke="none"
          fillRule="evenodd"
          fill="none"
          fillOpacity="1"
          strokeWidth="1"
        >
          <g transform="translate(-284.000000, -55.000000)">
            <g transform="translate(284.000000, 55.000000)">
              <rect
                fill="#8ed6ef"
                opacity="0.3"
                x="0"
                y="0"
                width="32"
                height="32"
                rx="16"
              ></rect>
              <path
                fill="#78B7CC"
                fillRule="nonzero"
                d="M15.9259259,7 C15.1339702,7 14.5707464,7.56076389 14.2928241,8.25925926 L9,8.25925926 L9,24 L22.8518519,24 L22.8518519,8.25925926 L17.5590278,8.25925926 C17.2811055,7.56076389 16.7178823,7 15.9259259,7 Z M15.9259259,8.25925926 C16.2751739,8.25925926 16.5555556,8.53964152 16.5555556,8.88888889 L16.5555556,9.51851852 L18.4444444,9.51851852 L18.4444444,10.7777778 L13.4074074,10.7777778 L13.4074074,9.51851852 L15.2962963,9.51851852 L15.2962963,8.88888889 C15.2962963,8.53964152 15.5766786,8.25925926 15.9259259,8.25925926 Z M10.2592593,9.51851852 L12.1481481,9.51851852 L12.1481481,12.037037 L19.7037037,12.037037 L19.7037037,9.51851852 L21.5925926,9.51851852 L21.5925926,22.7407407 L10.2592593,22.7407407 L10.2592593,9.51851852 Z M11.5185185,13.2962963 L11.5185185,16.4444444 L14.6666667,16.4444444 L14.6666667,13.2962963 L11.5185185,13.2962963 Z M15.9259259,13.9259259 L15.9259259,15.1851852 L20.3333333,15.1851852 L20.3333333,13.9259259 L15.9259259,13.9259259 Z M12.7777778,14.5555556 L13.4074074,14.5555556 L13.4074074,15.1851852 L12.7777778,15.1851852 L12.7777778,14.5555556 Z M11.5185185,17.7037037 L11.5185185,20.8518519 L14.6666667,20.8518519 L14.6666667,17.7037037 L11.5185185,17.7037037 Z M15.9259259,18.3333333 L15.9259259,19.5925926 L20.3333333,19.5925926 L20.3333333,18.3333333 L15.9259259,18.3333333 Z"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
